import React from 'react'
import type { SvgIconProps } from '@material-ui/core/SvgIcon'
import SvgIcon from '@material-ui/core/SvgIcon'

const CancelledEventIcon = (props: SvgIconProps) => (
  <SvgIcon viewBox={'0 0 22 19'} {...props}>
    <svg width="22" height="19" viewBox="0 0 22 19" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M3.57655 1.29541V2.42041H1.79633C0.813503 2.42041 0.0161133 3.17627 0.0161133 4.10791V5.79541H16.6315V4.10791C16.6315 3.17627 15.8341 2.42041 14.8513 2.42041H13.0711V1.29541C13.0711 0.673145 12.5407 0.17041 11.8842 0.17041C11.2278 0.17041 10.6974 0.673145 10.6974 1.29541V2.42041H5.95018V1.29541C5.95018 0.673145 5.41982 0.17041 4.76337 0.17041C4.10691 0.17041 3.57655 0.673145 3.57655 1.29541ZM16.6315 6.92041H0.0161133V16.4829C0.0161133 17.4146 0.813503 18.1704 1.79633 18.1704H14.8513C15.8341 18.1704 16.6315 17.4146 16.6315 16.4829V6.92041Z"
        fill="#738198"
      />
      <path
        d="M21.4335 10.2508C21.4335 12.9266 19.2637 15.0959 16.5874 15.0959C13.911 15.0959 11.7412 12.9271 11.7412 10.2508C11.7412 7.57446 13.911 5.40576 16.5874 5.40576C19.2637 5.40576 21.4335 7.57502 21.4335 10.2508Z"
        fill="#DE3E2D"
      />
      <path d="M13.7144 10.251H19.4604" stroke="white" strokeWidth="0.7" strokeLinecap="round" />
    </svg>
  </SvgIcon>
)
export default CancelledEventIcon
